import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, of, Subject, Subscription } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { FormBuilder, Validators } from '@angular/forms';
import { PlantService } from '../../../../../core/plant-configuration/_services/plant.service';
import { AuthService } from '../../../../../core/auth';
import { CompanyService } from '../../../../../core/auth/_services/company.service';
import { ProductTypeService } from '../../../../../core/plant-configuration/_services/product-type.service';
import { ProductPackageService } from '../../../../../core/plant-configuration/_services/product-package.service';
import { ProductPackageWeightService } from '../../../../../core/plant-configuration/_services/product-package-weight.service';
import { ProductPackageUnitService } from '../../../../../core/plant-configuration/_services/product-package-unit.service';
import { ProductProcessService } from '../../../../../core/plant-configuration/_services/product-process.service';
import { ProductService } from '../../../../../core/plant-configuration';

@Component({
  selector: 'kt-product-edit',
  templateUrl: './product-edit.component.html',
  styleUrls: []
})
export class ProductEditComponent implements OnInit, OnDestroy, AfterViewInit {
  itemObs = new Subject<any[]>();
  editObs = new Subject<number>();
  addObs = new Subject<number>();
  private itemFormOptions = {
    name: ["", Validators.required],
    product_packaging_weight_id: [null, ],
    product_packaging_id: [null, ],
    product_packaging_units_id: [null, ],
    product_process_id: [null, ],
    product_type_id: [null, ],
    // company_id: ["-1", Validators.required],
  };
  itemForm = this.formBuilder.group(this.itemFormOptions);
  stepList: any[] = [
    {
      icon: "flaticon2-architecture-and-city", title: "Datos del producto", subTitle: "Ingrese datos del producto", form: [
        [
          { name: "name", label: "Nombre", type: "text" },
          { name: "product_type_id", label: "Tipo de producto", type: "list", optionList: []},
        ],
		[
			{ name: "product_process_id", label: "Proceso", type: "list", optionList: []},
		],
      ]
	},{
	  icon: "flaticon2-architecture-and-city", title: "Información del empaquetado", subTitle: "Ingrese datos del empaquetado", form: [
        [
          { name: "product_packaging_id", label: "Formato", type: "list", optionList: []},
          { name: "product_packaging_weight_id", label: "Peso", type: "list", optionList: []},
        ],
		[
			{ name: "product_packaging_units_id", label: "Unidad", type: "list", optionList: []},
		],
      ]
    },
  ];

	private subscriptions: Subscription[] = [];
	data: any = {};
	partnerList: any[];
	userList: any[];
	uid: number = -1;
	company: any = null;
	packageList: any[] = [];
	productTypeList: any[] = [];
	unitList: any[] = [];
	weightList: any[] = [];
	processList: any[] = [];

  constructor(
    private productService: ProductService,
	private productTypeService: ProductTypeService,
	private productPackageService: ProductPackageService,
	private productPackageWeightService: ProductPackageWeightService,
	private productPackageUnitService: ProductPackageUnitService,
	private productProcessService: ProductProcessService,
    // private companyService: CompanyService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.uid = this.authService.getUID();
	this.subscriptions.push(
		of(null).pipe(
			switchMap(()=>combineLatest([
				this.productTypeService.getAll(),
				this.productPackageService.getAll(),
				this.productPackageUnitService.getAll(),
				this.productPackageWeightService.getAll(),
				this.productProcessService.getAll()
			]))
		).subscribe(([productTypeList, packageList, unitList, weightList, processList])=>{
			this.productTypeList = productTypeList;
			this.packageList = packageList;
			this.unitList = unitList;
			this.weightList = weightList;
			this.processList = processList;

			this.stepList[0].form[0][1].optionList = productTypeList.map(productType=>{
				return {text: productType.name, value: productType.id}
			});
			this.stepList[0].form[1][0].optionList = processList.map(process=>{
				return {text: process.name, value: process.id}
			});
			this.stepList[1].form[0][0].optionList = packageList.map(package_=>{
				return {text: package_.name, value: package_.id}
			});
			this.stepList[1].form[0][1].optionList = weightList.map(weight=>{
				return {text: weight.name, value: weight.id}
			});
			this.stepList[1].form[1][0].optionList = unitList.map(unit=>{
				return {text: unit.name, value: unit.id}
			});
			
			this.data.productTypeList = productTypeList;
			this.data.packageList = packageList;
			this.data.unitList = unitList;
			this.data.weightList = weightList;
			this.data.processList = processList;
		})
	)
    // this.subscriptions.push(
    //     of(null).pipe(
    //         switchMap(()=>this.companyService.companyLoaded$),
    //         filter((companyLoaded)=>companyLoaded==true)
    //     ).subscribe((companyLoaded)=>{
    //       if(companyLoaded){
    //         this.company = this.companyService.getCurrentCompany();
    //       }
    //         // this.stepList[0].form[1][0].optionList = companyList.map(company=>{return{text:company.name, value:company.id}})
    //         // this.data.companyList = companyList;
    //     })
    // )
  }
  ngAfterViewInit() {

  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  onItemLoaded(item) {

    console.log("on item load:");
	console.dir(item);
  }

  getItem(itemId: number) {
    this.subscriptions.push(
      of(null).pipe(
        switchMap(() => this.productService.getById(itemId))
      ).subscribe(item => {
        this.onItemLoaded(item);
        this.itemObs.next(item);
      })
    )
  }

  addItem(item: any) {
    // item.create_uid = this.uid>0?this.uid:'null';
    // item.create_date = "now()";
    // item.is_installation_contact = 'true';
    // item.active = 'true';
    this.subscriptions.push(
      of(null).pipe(
        switchMap(() => this.productService.add(item))
      ).subscribe(newId => {
        this.addObs.next(newId);
      })
    )
  }

  editItem(item: any) {
    // item.write_uid = this.uid>0?this.uid:'null';
    // item.write_date = "now()";
    // item.is_installation_contact = 'true';
    this.subscriptions.push(
      of(null).pipe(
        switchMap(() => this.productService.edit(item))
      ).subscribe(status => {
        if (status == "success") this.editObs.next(item.id);
        else this.editObs.next(-1);
      })
    )
  }
}